// src/theme/theme.js

export const theme = {
  colors: {
    primary: "#4D5C2B",
    secondary: "#8E9B56",
    success: "#6AA84F",
    error: "#CC0000",
    warning: "#FF9900",
    text: "#212529",
    background: "#ffffff",
  },
  font: {
    family: "'Inter', 'Roboto', 'Segoe UI', Arial, sans-serif",
    size: {
      small: "0.875rem",
      base: "1rem",
      large: "1.25rem",
      xlarge: "1.5rem",
    },
    weight: {
      regular: 400,
      medium: 500,
      bold: 600,
    },
  },
  borderRadius: {
    small: "6px",
    medium: "10px",
    large: "16px",
  },
  spacing: (factor) => `${factor * 8}px`, // Example: theme.spacing(2) -> "16px"
};
